import React from "react";
import { Spin } from "antd";
 
const LoadableButton = ({
  lable,
  type = "button",
  isLoading = false,
  loadingLable = "Loading...",
  className = "",
  onClick,
  disabled = false,
  children,
  isLoadingLableResponsive = false,
 
}) => {
  return (
 
    <button
      type={type}
      disabled={disabled || isLoading}
      onClick={onClick}
      className={`btn-primary ${className} ${isLoading || disabled ? "opacity-70 cursor-not-allowed" : ""
        }
        ${isLoadingLableResponsive ? '!px-1' : ''}`
 
      }
    >
      {isLoading ? (
        <div className="ant-white-spin space-x-4">
          <Spin size={isLoadingLableResponsive ? 'small' : 'default'} />
 
          <span className={`${isLoadingLableResponsive ? 'text-xs' : ''} `}>{loadingLable}</span>
        </div>
      ) : (
        <div className="flex items-center justify-center gap-2">
          {children ? children : <span>{lable}</span>}
        </div>
      )}
    </button>
  );
};
 
export default LoadableButton;